/* @flow */
import cx from 'classnames';
import * as React from 'react';
import Text from 'components/Text.jsx';

import './styles/AdminHeadline.scss';

type Props = {
  children: React.Node,
  flush?: boolean,
  full?: boolean,
};

const AdminHeadline = (props: Props) => {
  const { children, flush, full } = props;

  return (
    <Text
      element="div"
      lineHeight="xlarge"
      size="large"
      className={cx('AdminHeadline', {
        'AdminHeadline--flush': flush,
        'AdminHeadline--full': full,
      })}>
      {children}
    </Text>
  );
};

export default AdminHeadline;
